export default "__VITE_ASSET__77974f33__"